import { post } from '../axios'

// 设置讲解中
export function updateProductStatus(map) {
  return post(`${process.env.VUE_APP_LIVE}liveGoods/add`, map)
}

// 取消设置讲解中
export function cancelProduct(map) {
  return post(`${process.env.VUE_APP_LIVE}liveGoods/del`, map)
}

// 所有直播间列表
export function queryAllLiveRooms(map) {
  return post(`${process.env.VUE_APP_LIVE}liveInfo/getAllList`, map)
}

// 直播间列表
export function queryPageLiveRooms(map) {
  return post(`${process.env.VUE_APP_LIVE}liveInfo/list`, map)
}

// 新增直播间
export function addLiveRoom(map) {
  return post(`${process.env.VUE_APP_LIVE}liveInfo/add`, map)
}

// 更新直播间
export function updateLiveRoom(map) {
  return post(`${process.env.VUE_APP_LIVE}liveInfo/update`, map)
}

// 删除直播间
export function deleteLiveRoom(map) {
  return post(`${process.env.VUE_APP_LIVE}liveInfo/del`, map)
}

// 活动通知列表
export function queryPageLiveNotify(map) {
  return post(`${process.env.VUE_APP_LIVE}liveNotify/list`, map)
}

// 新增活动通知
export function addLiveNotify(map) {
  return post(`${process.env.VUE_APP_LIVE}liveNotify/add`, map)
}

// 修改活动通知
export function updateLiveNotify(map) {
  return post(`${process.env.VUE_APP_LIVE}liveNotify/update`, map)
}

// 删除活动通知
export function deleteLiveNotify(map) {
  return post(`${process.env.VUE_APP_LIVE}liveNotify/del`, map)
}

// 优惠券列表
export function queryPageLiveCoupon(map) {
  return post(`${process.env.VUE_APP_LIVE}liveCoupon/list`, map)
}

// 新增优惠券
export function addLiveCoupon(map) {
  return post(`${process.env.VUE_APP_LIVE}liveCoupon/add`, map)
}

// 修改优惠券
export function updateLiveCoupon(map) {
  return post(`${process.env.VUE_APP_LIVE}liveCoupon/update`, map)
}

// 删除优惠券
export function deleteLiveCoupon(map) {
  return post(`${process.env.VUE_APP_LIVE}liveCoupon/del`, map)
}

// 主播列表
export function queryPageAnchorRecommend(map) {
  return post(`${process.env.VUE_APP_LIVE}anchorRecommend/list`, map)
}

// 新增主播
export function addAnchorRecommend(map) {
  return post(`${process.env.VUE_APP_LIVE}anchorRecommend/add`, map)
}

// 更新主播
export function updateAnchorRecommend(map) {
  return post(`${process.env.VUE_APP_LIVE}anchorRecommend/update`, map)
}

// 删除主播
export function deleteAnchorRecommend(map) {
  return post(`${process.env.VUE_APP_LIVE}anchorRecommend/del`, map)
}

// 主播推荐和取消推荐
export function recommend(map) {
  return post(`${process.env.VUE_APP_LIVE}anchorRecommend/recommend`, map)
}
